import Configurazioni from "../";

const routes = [
	{ name: "ConfigurazioniPage", path: "/configurazioni", component: Configurazioni.ConfigurazioniPage },
	{ name: "ConfigurazioniMagazzinoPage", path: "/configurazionemagazzino", component: Configurazioni.ConfigurazioniMagazzinoPage },
	{ name: "ConfigurazioniContabilitaPage", path: "/configurazionecontabilita", component: Configurazioni.ConfigurazioniContabilitaPage },
	{ name: "ConfigurazioneGeneralePage", path: "/configurazionegenerale", component: Configurazioni.ConfigurazioneGeneralePage },
	{ name: "ConfigurazioneGeneraleVociMenuListPage", path: "/configurazionegenerale/vocimenu", component: Configurazioni.ConfigurazioneGeneraleVociMenuListPage, meta: { title: "Lista Voci Menu" } },
	{ name: "ConfiguraizoneGeneralePazientiMenuListPage", path: "/configurazionegenerale/pazientimenu", component: Configurazioni.ConfigurazioneGeneralePazientiMenuListPage, meta: { title: "Lista Voci Menu Pazienti" } },
];

export default routes;
